"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var UserStore_1 = require("stores/UserStore");
var QueriesStore_1 = require("stores/QueriesStore");
var IPCRowInput_1 = __importStar(require("../stage-2/IPCRowInput"));
var use_stores_1 = require("../../../../../hooks/use-stores");
var delete_svg_1 = __importDefault(require("res/img/delete.svg"));
var edit_svg_1 = __importDefault(require("res/img/edit.svg"));
var PODIPCTable = function (_a) {
    var data = _a.data, rowEditID = _a.rowEditID, currentStage = _a.currentStage, queryType = _a.queryType, onCreateRow = _a.onCreateRow, onSaveRow = _a.onSaveRow, onEditRow = _a.onEditRow, onDeleteRow = _a.onDeleteRow, busy = _a.busy, currentStage3 = _a.currentStage3, status = _a.status, dummyOrder = _a.dummyOrder;
    var userStore = use_stores_1.useStores().userStore;
    return (react_1.default.createElement("div", { className: "pod-ipc-table ipc-table" },
        react_1.default.createElement("div", { className: "ipc-table__head" },
            react_1.default.createElement("div", { className: "ipc-table__row flex flex-row" },
                react_1.default.createElement("div", { className: "ipc-table__col" }, "Type"),
                react_1.default.createElement("div", { className: "ipc-table__col" }, "IPC Number"),
                react_1.default.createElement("div", { className: "ipc-table__col" }, "Quantity"),
                react_1.default.createElement("div", { className: "ipc-table__col" }, "Line Item Text"),
                react_1.default.createElement("div", { className: "ipc-table__col" }, dummyOrder && "Dummy Order Number" || "Order Number / Returns Ref"),
                react_1.default.createElement("div", { className: "ipc-table__col" }, "Delivery Note"),
                react_1.default.createElement("div", { className: "ipc-table__col" }, "Goods Issued"))),
        react_1.default.createElement("div", { className: "ipc-table__tbody" }, data.map(function (item) { return rowEditID !== item.id ? (react_1.default.createElement("div", { className: "ipc-table__row flex flex-row", key: item.id },
            react_1.default.createElement("div", { className: "ipc-table__col flex flex-row" },
                userStore.hasPermission(UserStore_1.Permissions.POD_QUERY_STAGE_3_EDIT) &&
                    react_1.default.createElement("button", { type: "button", title: "Delete Row", onClick: function () { onDeleteRow(item.id); } },
                        react_1.default.createElement("img", { src: delete_svg_1.default, alt: "Delete" })),
                userStore.hasPermission(UserStore_1.Permissions.POD_QUERY_STAGE_3_EDIT) &&
                    react_1.default.createElement("button", { type: "button", title: "Edit Row", onClick: function () { onEditRow(item.id); } },
                        react_1.default.createElement("img", { src: edit_svg_1.default, alt: "Edit" })),
                item.ipcType),
            react_1.default.createElement("div", { className: "ipc-table__col" }, item.ipcNumber),
            react_1.default.createElement("div", { className: "ipc-table__col" }, item.quantity),
            react_1.default.createElement("div", { className: "ipc-table__col" }, item.creditText),
            react_1.default.createElement("div", { className: "ipc-table__col" }, item.orderNumberReturnRef),
            react_1.default.createElement("div", { className: "ipc-table__col" }, item.deliveryNote),
            react_1.default.createElement("div", { className: "ipc-table__col" }, item.goodsIssue ? "Yes" : "No"))) : (react_1.default.createElement(IPCRowInput_1.default, { type: IPCRowInput_1.InputTypes.EDIT, queryType: queryType, onSubmit: onSaveRow, busy: busy, currentData: item, currentStage3: currentStage3, dummyOrder: dummyOrder })); })),
        status !== QueriesStore_1.QueryStatus.COMPLETED &&
            currentStage === 3 &&
            currentStage3 === QueriesStore_1.PODStage3Parts.WAREHOUSE_1 &&
            userStore.hasPermission(UserStore_1.Permissions.POD_QUERY_WAREHOUSE_TEAM) &&
            react_1.default.createElement(IPCRowInput_1.default, { queryType: queryType, onSubmit: onCreateRow, busy: busy, currentStage3: currentStage3, dummyOrder: dummyOrder })));
};
exports.default = PODIPCTable;
